import { Form } from "react-final-form";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import ServiceTransportModalFormStepOne from "./ServiceTransportModalFormSteps/ServiceTransportModalFormStepOne";


const ServiceTransportModalForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  const minRate =
    initialValues?.device?.printerModel?.servicePrice?.minRateTransportPrice;

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={{
        ...initialValues,
        isStaticRateTransportPriceService: minRate > 0,
      }}
      onSubmit={() => { }}
      validate={() => { }}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServiceTransportModalForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceTransportModalFormStepOne {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceTransportModalForm;
